export const ACTION_GET_PETS = 'ACTION_GET_PETS'
export const ACTION_GET_SPECIES = 'ACTION_GET_SPECIES'
export const ACTION_GET_RACES = 'ACTION_GET_RACES'
export const ACTION_CREATE_PET = 'ACTION_CREATE_PET'
export const ACTION_UPDATE_PET = 'ACTION_UPDATE_PET'
export const ACTION_DELETE_PET = 'ACTION_DELETE_PET'
export const ACTION_SET_SELECTED_PET = 'ACTION_SET_SELECTED_PET'

export const SET_PET_LIST = 'SET_PET_LIST'
export const SET_SPECIES_LIST = 'SET_SPECIES_LIST'
export const SET_RACE_LIST = 'SET_RACE_LIST'
export const SET_SELECTED_PET = 'SET_SELECTED_PET'
export const RESET_PETS_STATE = 'RESET_PETS_STATE'

export const PET_LIST_KEY = 'petList'
export const SPECIES_LIST_KEY = 'speciesList'
export const RACE_LIST_KEY = 'raceList'
export const SELECTED_PET_KEY = 'selectedPet'
